// Tier-2 <EmptyState> backed by AntD Empty (FORT-182). A "no data" placeholder
// with an optional action (e.g. a "Create" button). Spacing above the action
// comes from tokens — no raw px at the call site.
import React from 'react';
import { Empty as AntEmpty } from 'antd';
import { useTokens } from '../../core/theme/TokensProvider';
import type { CommonProps } from './types';

export interface EmptyStateProps extends CommonProps {
  description?: React.ReactNode;
  image?: React.ReactNode;
  /** Rendered below the description (e.g. a call-to-action button). */
  action?: React.ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  description,
  image,
  action,
  className,
  style,
  'data-testid': dataTestId,
}) => {
  const tokens = useTokens();
  return (
    <AntEmpty
      description={description}
      image={image ?? undefined}
      className={className}
      style={style}
      data-testid={dataTestId}
    >
      {action && <div style={{ marginTop: tokens.space[3] }}>{action}</div>}
    </AntEmpty>
  );
};
